import React from 'react'
import { t } from '../../../utils'
import styles from './ReadMoreButton.module.scss'

const ReadMoreButton = ({onClickHandler, isFullTextVisible}) => {
    return (
        <span onClick={onClickHandler}>
          {!isFullTextVisible && '...'}<br/>
            <span className={styles.readMoreButton}>{isFullTextVisible ? t().readLess : t().readMore}</span>
        </span>
            );
};

export default ReadMoreButton
